const ITEMS = [
  "Driven by Integrity",
  "Powered by Precision",
  "Committed to Your Success",
  "Precision Dispatching",
  "Strategic Load Planning",
  "Carrier-Focused Support",
];

const TAGS = { 1: "#EveryMileMatters", 4: "#BHDispatch" };

export const Marquee = () => (
  <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-gold/20 bg-[#0c0c0c] py-5" aria-hidden="true">
    <div className="marquee-skew">
      <div className="marquee-track">
        {[0, 1].map((dup) => (
          <div key={dup} className="flex shrink-0 items-center">
            {ITEMS.map((item, i) => (
              <span key={`${dup}-${item}`} className="flex items-center">
                <span className="font-display text-2xl sm:text-3xl uppercase tracking-[0.08em] marquee-outline px-8 whitespace-nowrap">
                  {item}
                </span>
                <span className="text-gold text-lg">◆</span>
                {TAGS[i] && (
                  <>
                    <span className="font-graffiti graffiti-glow text-2xl sm:text-3xl text-champagne px-8 whitespace-nowrap -rotate-2 inline-block">
                      {TAGS[i]}
                    </span>
                    <span className="text-gold text-lg">◆</span>
                  </>
                )}
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  </div>
);
